import RandevSeed from "../lib/seed";

const ACCENTS = ["cobalto", "minio", "menta"];

export const accentName = (seed) => ACCENTS[seed % 3];
export const seedLabel = (seed) => RandevSeed.label(seed);

// Semilla del día: fecha en día-mes (8 de octubre = 810).
export const seedFromDate = (date) => date.getDate() * 100 + (date.getMonth() + 1);

function Module({ cell, x, y }) {
  switch (cell) {
    case "q0": return <path d={`M${x} ${y}h1A1 1 0 0 1 ${x} ${y + 1}z`} />;
    case "q1": return <path d={`M${x + 1} ${y}v1A1 1 0 0 1 ${x} ${y}z`} />;
    case "q2": return <path d={`M${x + 1} ${y + 1}h-1A1 1 0 0 1 ${x + 1} ${y}z`} />;
    case "q3": return <path d={`M${x} ${y + 1}V${y}A1 1 0 0 1 ${x + 1} ${y + 1}z`} />;
    case "circle": return <circle cx={x + 0.5} cy={y + 0.5} r="0.5" />;
    case "square": return <rect x={x} y={y} width="1" height="1" />;
    case "dot": return <circle cx={x + 0.5} cy={y + 0.5} r="0.16" />;
    default: return null;
  }
}

export function Seed({ seed = 1, size, animate = false, ink = "var(--tinta)", className = "" }) {
  const { cells, accent } = RandevSeed.layout(seed);
  const acc = `var(--${accentName(seed)})`;
  return (
    <svg
      viewBox="0 0 4 4"
      width={size}
      height={size}
      className={`seed ${className}`}
      role="img"
      aria-label={`Semilla ${seedLabel(seed)}`}
    >
      {cells.map((cell, i) => {
        if (cell === "empty") return null;
        const fill = i === accent ? acc : ink;
        return (
          <g
            key={i}
            fill={fill}
            stroke={fill}
            strokeWidth="0.012"
            className={animate ? "seed-mod" : undefined}
            style={animate ? { animationDelay: `${i * 30}ms` } : undefined}
          >
            <Module cell={cell} x={i % 4} y={Math.floor(i / 4)} />
          </g>
        );
      })}
    </svg>
  );
}

export function SeedTag({ seed = 1, children, inverse = false }) {
  return (
    <span className={`seed-tag${inverse ? " seed-tag--inv" : ""}`}>
      <span className="seed-tag-dot" style={{ background: `var(--${accentName(seed)})` }} />
      <span className="seed-tag-n">{seedLabel(seed)}</span>
      {children ? <span className="seed-tag-l">{children}</span> : null}
    </span>
  );
}
